import React from 'react';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import LoginFormWrapper from './components/LoginFormWrapper.component';
import SignInAsGuestLink from 'src/components/SignInAsGuestLink/SignInAsGuestLink.component';
import MainLogo from 'src/components/MainLogo/MainLogo';
import { parseJSON } from 'src/utils/common.util';
import TabletLogoBanner from 'src/assets/images/banner/tablet.png';
import DesktopLogoBanner from 'src/assets/images/banner/desktop.png';
import MobileLogoBanner from 'src/assets/images/banner/mobile.png';

const LoginView: React.FC = () => {

  React.useEffect(() => {
    sessionStorage.removeItem('guestSubmission');
  });

  const matches = useMediaQuery('(max-width:768px)')
  const isIpadLg = useMediaQuery('(max-width:1024px)')

  const isTablet = matches || isIpadLg;
  const isMobile = useMediaQuery('(max-width:600px)');

  let Logo = DesktopLogoBanner;

  if (isMobile) {
    Logo = MobileLogoBanner;
  } else if (isTablet) {
    Logo = TabletLogoBanner;
  }

  return  (
    <Container className="login" maxWidth={false} disableGutters={true}>
      <Grid direction={isTablet ? 'row' : 'row-reverse'} container={true} className="login__left-wrapper">
        <Grid  item={true} sm={isTablet ? 12 : 7} className="login__right-container">
          <img src={Logo} alt="Home Banner" className="login__banner" />
        </Grid>
        <Grid item={true} sm={isTablet ? 12 : 5} className="login__left-container">
          <div className="login__logo-wrapper">
            <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
          </div>
          <div className="login__form-wrapper">
            <LoginFormWrapper />
          </div>

          <SignInAsGuestLink />
          <div />
        </Grid>

      </Grid>
    </Container>
  )
};

export default LoginView;
